"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DocumentUtil {
}
DocumentUtil.createElement = (rootElementId) => {
    let rootElement = document.getElementById(rootElementId);
    if (!rootElement) {
        rootElement = document.createElement('div');
        rootElement.setAttribute('id', rootElementId);
        rootElement.setAttribute('class', 'ClubAdminApp');
        document.body.appendChild(rootElement);
    }
    return rootElement;
};
exports.default = DocumentUtil;
